var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid footer_instagram bg-black" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "insta_scroll w-100" }, [
          _c(
            "div",
            {
              staticClass: "glide__track",
              attrs: { "data-glide-el": "track" },
            },
            [
              _c(
                "ul",
                {
                  staticClass:
                    "glide__slides d-flex flex-row justify-content-start",
                },
                _vm._l(_vm.paneldata.items, function (item, index) {
                  return _c(
                    "li",
                    {
                      key: "image_" + item.title + "_" + index,
                      staticClass: "glide__slide",
                    },
                    [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: item.link,
                            target: "_blank",
                            title: item.image.alt + "- Instagram Post",
                          },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(item.title) +
                              "\n                            "
                          ),
                          _c("img", {
                            attrs: { src: item.image.url, alt: item.image.alt },
                          }),
                        ]
                      ),
                    ]
                  )
                }),
                0
              ),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row py-3" }, [
      _c("div", { staticClass: "col-12 insta_cta text-center" }, [
        _c(
          "a",
          {
            attrs: {
              href: "https://www.instagram.com/cincyexperience/",
              target: "_blank",
            },
          },
          [_vm._v("STAY IN THE KNOW - FOLLOW US ON INSTAGRAM")]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }